import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from '../commons/config.service';
import { CartService } from '../commons/cart.service';
import { UtilitiesService } from '../commons/utilities.service';
import { BraintreePaymentService } from '../commons/braintree-payment.service';
import { PaymentType } from '../commons/models';


declare var fbq: Function;


@Component({
  template: require('./checkout.component.html'),
  styles: [`
     .form-step-header{ color:#fff; background-color:#333; padding:8px 6px; margin:10px 0 10px;
       font-size:19px; text-transform:uppercase;}
       .step-content{ margin-bottom:20px;}
  `]

})

export class CheckoutComponent implements OnInit {

  @ViewChild('braintreeContainer')
  braintreeContainer;
  enabledConfirmOrder: boolean = false;

  public get selPaymentType(): PaymentType {
    return this.cartService.cart.paymentType;
  }
  public set selPaymentType(type: PaymentType) {
    this.cartService.cart.paymentType = type;
  }

  public get selDeliveryOptionId(): number {
    return this.cartService.cart.SelDeliveryOption.id;
  }
  public set selDeliveryOptionId(id: number) {
    this.cartService.cart.SelDeliveryOption = this.config.deliveryOptions.filter(v => v.id === id)[0];
  }

  constructor(
    public config: ConfigService,
    private router: Router,
    public cartService: CartService,
    public utilities: UtilitiesService,
    private braintreePayment: BraintreePaymentService) {
  }

  ngOnInit() {

    //console.log('ngOnInit - cartCheckProducts:');
    this.cartService.cartCheckProducts();
    this.cartService.cartCheckCROPPED();


    fbq('track', 'InitiateCheckout');

    this.utilities.cartTOTAL();
    //console.log('onInit');
    this.cartService.cart.checkoutStepIndex = 1;
    this.changeStep(1);
    //console.log(this.cartService.cart);

    this.cartService.cart.TOTALCartORDER = this.cartService.cart.totalALLPriceStatic;
    this.cartService.cart.couponLabel = null;
  }

  onShipmentChange(value: string) {
    this.utilities.cartTOTAL();
    //console.log('onCountryChange');
    this.cartService.cart.paymentNonce = null;
  }

  isEnabled(): boolean {
    if (this.cartService.cart.checkoutStepIndex < 5) {
      return true;
    } else {
      return false;
    }
  }

  changeStep(newStep: number) {
    //console.log(this.cartService.cart.checkoutStepIndex);
    // controllo per non tornare indietro una volta arrivati al pagamento
    if (newStep < this.cartService.cart.checkoutStepIndex && this.cartService.cart.checkoutStepIndex !== 5) {
      this.cartService.cart.checkoutStepIndex = newStep;
      this.cartService.cart.paymentNonce = null;
      //console.log(newStep);
    } else {
      //console.log('tentativo di changeStep', newStep);
    }

  }

  frmShipmentSubmit(f) {
    this.cartService.cart.paymentNonce = null;
    // alert('ok ship | ' + f.value.shipmentName);
    this.cartService.cart.checkoutStepIndex = 2;
    this.cartService.saveCart();
  }


  frmShipmentTypeSubmit(f) {

    this.cartService.cart.checkoutStepIndex = 3;
    this.cartService.saveCart();
  }

  frmInvoiceSubmit(f) {
    // alert('ok invoic | ' + f.value.name);

    this.cartService.cart.paymentNonce = null;
    if (!this.cartService.cart.billing.TaxCode && !this.cartService.cart.billing.VatNumber) {
      alert('inserire almeno Codice Fiscale o P.IVA ');
      return;
    }
    if(!!this.cartService.cart.billing.VatNumber && !this.cartService.cart.billing.CodeSDI && !this.cartService.cart.billing.PEC) {
      alert('obbligatorio il codice SDI oppure la PEC');
      return;
    }

    this.cartService.cart.checkoutStepIndex = 4;
    this.cartService.saveCart();

    fbq('track', 'AddPaymentInfo');
  }


  frmPaymentTypeSubmit(f) {
    //console.log('frmPaymentTypeSubmit');

    this.cartService.cart.checkoutStepIndex = 5;
    this.cartService.saveCart();

    this.enabledConfirmOrder = false;

    if (this.braintreeContainer.nativeElement.innerHTML.length > 0) { // = 'inizializzazione braintree...';
      //console.log('braintree-dropin è già stato inizializzato per sicurezza quindi ricarico la pagina per resettare il DOM');
      this.router.navigate(['/']);
      this.router.navigate(['/checkout']);
    }

    if (this.cartService.cart.paymentType === PaymentType.Braintree) {

      // let checkout;

      // this.braintreePayment.setup('CLIENT_TOKEN_FROM_SERVER', 'dropin', {
      //   onReady: function (integration) {
      //     checkout = integration;
      //   }
      // });

      const that = this;
      this.utilities.cartTOTAL( price => {
        this.braintreePayment.setup({
          container: 'braintree-container',
          price: price,

          // onReady: () => {
          onReady: function (integration) {
            // checkout = integration;
            that.enabledConfirmOrder = true;
            //console.log('braintree', 'onReady');
          },
          onError: error => {
            alert('braintree - error: ' + error);
          }
        },
          onPaymentMethodReceived => {
            //console.log('braintree', 'method - onPaymentMethodReceived');
            this.cartService.cart.paymentNonce = onPaymentMethodReceived.nonce;
            this.closeOrder(onPaymentMethodReceived.nonce);
          });

        // // When you are ready to tear down your integration
        // checkout.teardown(function () {
        //   checkout = null;
        //   //console.log('checkout.teardown');
        //   // braintree.setup can safely be run again!
        // });

      });
    } else { // BONIFICO
      this.enabledConfirmOrder = true;
    }
  }

  frmEndOrderSubmit(f: HTMLFormElement) {
    // Se è Braintree lo fa sopra
    //console.log('frmEndOrderSubmit');
    if (this.selPaymentType === PaymentType.Bank) {
      //console.log('frmEndOrderSubmit | this.selPaymentType === PaymentType.Bank | closeOrder');
      this.closeOrder();
    }
  }



  closeOrder(paymentNonce: string = null) {
    //console.log('closeOrder');

    $('#mdCloseOrder').hide();
    $('#loaderApp').show();


    this.cartService.cart.billingAddress = this.cartService.cart.shipmentAddress;
    this.cartService.cart.deliveryOptionName = this.cartService.cart.SelDeliveryOption.name;

    this.cartService.cart.paymentNonce = paymentNonce;

    //console.log('paymentNonce ' + paymentNonce);
    //console.log(this.cartService.cart);

    this.utilities.requestAngular2('cartAllData', this.cartService.cart).subscribe(
      result => {
        //console.log(result);

        if (result.Item1 === 'ok') {
          $('#mdCloseOrder').modal('hide');
          // this.router.navigate(['/order-completed']);
          // this.router.navigate(['/order-completed', { idTransaction: result.Item2 }]);
          this.router.navigate(['/order-completed/' + result.Item2]);

        } else {
          alert('Chiusura ordine fallita \r\n verifica tutti i dati');
          $('#loaderApp').hide();
        }
      },
      error => {
        alert('Chiusura ordine fallita \r\n sito in errore');
        $('#loaderApp').hide();
        console.error(error);
      }
    );
  }

  public emailChanged() {
    //console.log('emailChanged');
    this.utilities.cartTOTAL();
  }

  public applyCoupon(couponField: HTMLInputElement) {
    this.utilities.CalculateCoupon(couponField.value, null, true);
    this.utilities.cartTOTAL();
    couponField.value = '';
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/checkout.component.ts